import {
  Captions,
  Download,
  Plus,
  ReceiptText,
  Share2,
  Text,
  ThumbsDown,
  ThumbsUp,
} from 'lucide-react';

import { Button } from '@kit/ui/button';
import { If } from '@kit/ui/if';
import { cn } from '@kit/ui/utils';

interface VideoActionsProps {
  likes: string;
  onDataChange: (key: string, value: string) => void;
  isEditable?: boolean;
}

const ALLOW_DOWNLOAD = false;

export default function VideoActions({
  likes,
  onDataChange,
  isEditable,
  setCurrentView,
  currentView,
  downloadVideo,
}: VideoActionsProps) {
  return (
    <div className="flex items-center justify-between border-b border-t px-4 py-2">
      <div className="flex items-center space-x-4">
        <Button
          variant="ghost"
          className="flex items-center space-x-1"
          disabled
        >
          <ThumbsUp className="h-5 w-5" />
          <span
            className="outline-none"
            contentEditable={isEditable}
            onBlur={(e) =>
              onDataChange('likes', e.currentTarget.textContent || '')
            }
            suppressContentEditableWarning
          >
            {likes}
          </span>
        </Button>
        <Button
          variant="ghost"
          className="hidden items-center space-x-1 2xl:flex"
          disabled
        >
          <ThumbsDown className="h-5 w-5" />
        </Button>
      </div>
      <div className="flex items-center space-x-4">
        <Button
          variant="ghost"
          className={cn('flex items-center space-x-1', {
            ['text-primary bg-primary/10']: currentView === 'description',
          })}
          onClick={() => setCurrentView('description')}
        >
          <Text className="h-5 w-5" />
          <span className="hidden 2xl:block">Description</span>
        </Button>
        <Button
          variant="ghost"
          className={cn('flex items-center space-x-1', {
            ['text-primary bg-primary/10']: currentView === 'transcript',
          })}
          onClick={() => setCurrentView('transcript')}
        >
          <Captions className="h-5 w-5" />
          <span className="hidden 2xl:block">Transcript</span>
        </Button>
        <Button
          variant="ghost"
          className={cn('flex items-center space-x-1', {
            ['text-primary bg-primary/10']: currentView === 'summary',
          })}
          onClick={() => setCurrentView('summary')}
        >
          <ReceiptText className="h-5 w-5" />
          <span className="hidden 2xl:block">Summary</span>
        </Button>
        <If condition={ALLOW_DOWNLOAD}>
          <Button
            variant="ghost"
            className={cn('flex items-center space-x-1', {
              ['text-primary bg-primary/10']: currentView === 'download',
            })}
            onClick={downloadVideo}
          >
            <Download className="h-5 w-5" />
          </Button>
        </If>
      </div>
    </div>
  );
}
